import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { asyncScheduler } from 'rxjs';

@Directive({
  selector: '[cueDynamicScrollSize]',
  standalone: true,
})
export class DynamicScrollSizeDirective implements AfterViewInit {
  private viewport = inject(CdkVirtualScrollViewport);
  private elRef = inject<ElementRef<HTMLDivElement>>(ElementRef<HTMLDivElement>);

  ngAfterViewInit(): void {
    (this.elRef.nativeElement.parentElement as HTMLDivElement).getBoundingClientRect().height;

    asyncScheduler.schedule(() => {
      this.elRef.nativeElement.style.height =
        this.elRef.nativeElement.parentElement.getBoundingClientRect().height + 'px';
      this.viewport.checkViewportSize();
    });
  }
}
